import React, { useState, useEffect, useContext, useRef } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { StockOutInnerStyle, StockOutFormStyle, StockOutItemListStyle } from './css/StockOutInnerStyle'
import { ContentInner } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import Expirations from './forms/expirations/Expirations'
import CloseButton from '../../layout/close_button/CloseButton'
import AutoCompleteList from '../../layout/AutoCompleteList'
import { filterItemsSearch } from '../../utilities/utilities'
import { stockOutControllerContext } from './StockOutController'
import { appContext } from '../../../App'

function StockOutForm() {
  const stockOutController = useContext(stockOutControllerContext)
  const [stockOut, setStockOut] = stockOutController.stockOut
  const { stockOutList, warehouses } = stockOutController
  const [activeInput, setActiveInput] = useState('')
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentStockOutList, setCurrentStockOutList] = useState([])

  const onChange = (e) => {
    const itemName = ['si_received_by', 'prepared_by', 'remarks']

    // Avoid unwanted character
    if (!keyPressed) return

    setStockOut({ ...stockOut, [e.target.name]: e.target.value })

    // If the item is not on the array then return
    if (!itemName.find(item => item === e.target.name)) return

    setActiveInput(e.target.name)
    const filteredItemList = filterItemsSearch(stockOutList.map(item => item[e.target.name]), e.target.value)
    setCurrentStockOutList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        if (e.target.name !== 'reference_code') {
          setCurrentStockOutList([])
          ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        }
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const onRemarksInputFocus = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => {
    if (activeInput) {
      if (currentStockOutList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => setStockOut({ ...stockOut, [activeInput]: value })}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={currentStockOutList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))
    }

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentStockOutList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOut.si_received_by, stockOut.prepared_by, stockOut.remarks, keyPressed, itemClicked])

  useEffect(() => {
    if (stockOut.dest_warehouse.name) {
      if (stockOut.dest_warehouse.name === stockOut.source_warehouse.name) {
        const onClick = () => {
          setStockOut({ ...stockOut, dest_warehouse: { name: '--None--', id: null } })
          ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
        }

        ReactDOM.render (
          <ModalWindow
            id='mw-parent'
            width='30'
            height='35'
            header='Set Warehouse'
            footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div>Warehouse Source and Warehouse Destination must not be the same.</div>
                <br />
                <div>Please choose a different warehouse destination.</div>
              </div>
              <div className='button-container'>
                <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
              </div>
            </div>
          </ModalWindow>,
          document.getElementById('modal-form-container') 
        )
      }
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOut.dest_warehouse, stockOut.source_warehouse])

  return (
    <React.Fragment>
      <div id='stock-out-form-container'>
        <div id='add-new-stock-header'>Pull-out Stocks</div>
        <hr />
        <div className='stock-out-form' id='source-warehouse-container'>
          <label htmlFor='warehouse'>Source Warehouse</label>
          <div className='input-container'>
            <select
              disabled={(stockOut.item_details.length) ? true : false}
              id='source-warehouse'
              name='source_warehouse'
              value={stockOut.source_warehouse.name}
              onChange={(e) => setStockOut({
                ...stockOut,
                source_warehouse: {
                  name: e.target.value,
                  id: warehouses.find(wh => wh.name === e.target.value)._id
                }
              })}>
              {
                (warehouses) ?
                  warehouses.map(warehouse => (
                    <option key={warehouse._id} style={{fontSize: '1rem'}}>{warehouse.name}</option>
                  ))
                : null
              }
            </select>
          </div>
        </div>
        <div className='stock-out-form' id='destination-warehouse-container'>
          <label htmlFor='warehouse'>Destination Warehouse</label>
          <div className='input-container'>
            <select
              id='dest-warehouse'
              name='dest_warehouse'
              value={stockOut.dest_warehouse.name}
              onChange={(e) => setStockOut({
                ...stockOut,
                dest_warehouse: {
                  name: e.target.value,
                  id: (e.target.value === '--None--') ? null : warehouses.find(wh => wh.name === e.target.value)._id
                }
              })}>
              <option style={{fontSize: '1rem'}}>--None--</option>
              {
                (warehouses) ?
                  warehouses.map(warehouse => (
                    <option key={warehouse._id} style={{fontSize: '1rem'}}>{warehouse.name}</option>
                  ))
                : null
              }
            </select>
          </div>
        </div>
        <div
          style={{display: (stockOut.dest_warehouse.name === '--None--') ? 'none' : 'flex'}}
          className='stock-out-form' id='si-received-by-container'>
          <label htmlFor='si-received-by'>Received By</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              type='text'
              id='si-received-by'
              name='si_received_by'
              placeholder='received by'
              value={stockOut.si_received_by}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
              <div id='si_received_by-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='stock-out-form' id='date-released-container'>
          <label htmlFor='date-released'>Date Released*</label>
          <div className='input-container'>
            <input
              type='date'
              id='date-released'
              name='date_released'
              placeholder='date released'
              value={stockOut.date_released}
              onChange={(e) => setStockOut({ ...stockOut, date_released: e.target.value})} />
          </div>
        </div>
        <div className='stock-out-form' id='prepared-by-container'>
          <label htmlFor='prepared-by'>Prepared By*</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='prepared_by'
              name='prepared_by'
              placeholder='prepared by'
              value={stockOut.prepared_by}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
            <div id='prepared_by-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='stock-out-form' id='reference-code-container'>
          <label htmlFor='reference-code'>Reference</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='reference_code'
              name='reference_code'
              placeholder='reference code'
              onKeyDown={onKeyDown}
              value={stockOut.reference_code}
              onChange={onChange}/>
          </div>
        </div>
        <div className='stock-out-form' id='stock-out-new-remarks-container'>
          <label htmlFor='stock-out-new-remarks'>Remarks</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='remarks'
              name='remarks'
              placeholder='remarks'
              value={stockOut.remarks}
              onKeyDown={onKeyDown}
              onFocus={onRemarksInputFocus}
              onChange={onChange}/>
            <div id='remarks-acl-container' className='acl-container'></div>
          </div>
        </div>
      </div>
      <StockOutFormStyle />
    </React.Fragment>
  )
}

function StockOutItemList() {
  const app = useContext(appContext)
  const stockOutItemDetailNameRef = useRef(null)
  const stockOutController = useContext(stockOutControllerContext)
  const [stockOut, setStockOut] = stockOutController.stockOut
  const [stockOutItemDetail, setStockOutItemDetail, resetStockOutItemDetail] = stockOutController.stockOutItemDetail
  const { productsList } = stockOutController
  const [itemUnitDescriptionList, setItemUnitDescriptionList] = useState([])
  const [currentProductsList, setCurrentProductsList] = useState([])
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentItemIndex, setCurrentItemIndex] = useState(null)
  const [currentItem, setCurrentItem] = useState(null)
  const [editMode, setEditMode] = useState(null)
  const [editButtonClick, setEditButtonClick] = useState(false)

  const [itemOK, setItemOK] = useState(false)
  const [currentUnitIsFractional, setCurrentUnitIsFractional] = useState(null)

  const onChange = (e) => {
    // Avoid unwanted characters to prevent regular expressions error on filter
    if (!keyPressed) return

    setStockOutItemDetail({ ...stockOutItemDetail, name: e.target.value })
    const filteredItemList = filterItemsSearch(productsList.map(product => product.item_full_description), e.target.value)
    setCurrentProductsList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setCurrentProductsList([])
        ReactDOM.unmountComponentAtNode(document.getElementById('name-acl-container'))
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const highlightItemDetailsRow = (itemIndex, highlight=false) => {
    const itemDetailsRow = document.getElementById(itemIndex+'item-details-row')
    if (highlight) itemDetailsRow.classList.add('highlight-item-details-row')
    else itemDetailsRow.classList.remove('highlight-item-details-row')
  }

  const onClickStockOutAddItem = async (e) => {
    const proceedAddingItem = () => {
      if (currentItemIndex !== null) { // It's on edit mode
        // Remove expirations array here
        delete stockOutItemDetail.expirations

        stockOut.item_details[currentItemIndex] = stockOutItemDetail

        setCurrentItemIndex(null)
        highlightItemDetailsRow(currentItemIndex, false)

      } else {
        // Remove expirations array here
        delete stockOutItemDetail.expirations

        setStockOut({ ...stockOut, item_details: [...stockOut.item_details, stockOutItemDetail] })
      }

      // Resets
      resetStockOutItemDetail()
      setCurrentItem(null)

      stockOutItemDetailNameRef.current.focus()
      stockOutItemDetailNameRef.current.scrollIntoView()

      setEditMode(false)
    }

    const showExpirationsForm = () => {
      const cb = (res) => {
        proceedAddingItem()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }

      ReactDOM.render(
        <ModalWindow
          id='mw-parent'
          width='30'
          height='50'
          header='Select Expiration Date'
          footer={(stockOutItemDetail.expiration_date)
            ? `Edit Expiration Date: ${stockOutItemDetail.expiration_date}`
            : null
          }>
          <Expirations stockOutItemDetail={stockOutItemDetail} app={app} cb={cb}/>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }
    // Display a window with the list of expirations date
    // if there are any
    if (stockOutItemDetail.expirations) {
      showExpirationsForm()
    } else { proceedAddingItem() }
  }

  const onClickDDButton = (e) => {
    const dd_menu = e.target.closest('.dd-menu')
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })

    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    action_btn_menu.classList.toggle('show-dd-menu')
  }

  const onDDFocus = (e) => {
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })
  }

  const onClickStockOutEditItem = (e) => {
    // Hide pop-up action button
    const dd_menu = e.target.closest('.dd-menu')
    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    if (action_btn_menu.classList.contains('show-dd-menu'))
      action_btn_menu.classList.remove('show-dd-menu')

    const itemIndex = parseInt(e.target.id)
    setCurrentItemIndex(itemIndex)
    setStockOutItemDetail(stockOut.item_details[itemIndex])

    // Highlight the stock in item detail being edited
    highlightItemDetailsRow(itemIndex, true)

    // Disable the elipse button
    setEditMode(true)
    setEditButtonClick(true)

    stockOutItemDetailNameRef.current.focus()
    stockOutItemDetailNameRef.current.scrollIntoView()
  }

  const onClickStockOutDeleteItem = (e) => {
    const itemIndex = parseInt(e.target.id)

    setStockOut({ ...stockOut, item_details: stockOut.item_details.filter((item, index) => itemIndex !== index) })

    stockOutItemDetailNameRef.current.focus()
    stockOutItemDetailNameRef.current.scrollIntoView()
  }

  const onClickRemoveExpirationDate = (e) => {
    const close_button = e.target.closest('.close-button')
    const item_index = parseInt(close_button.id)
    stockOut.item_details[item_index].expiration_date = ''
    setStockOut({ ...stockOut, item_details: stockOut.item_details })
  }

  const onFocusItemNameInput = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => {
    if (currentProductsList.length > 0)
      ReactDOM.render(
        <AutoCompleteList
          valueSetter={(value) => setStockOutItemDetail({ ...stockOutItemDetail, name: value })}
          keyPressed={keyPressed}
          setItemClicked={setItemClicked}
          items={currentProductsList}
        />, document.getElementById('name-acl-container')
      )
    else
      ReactDOM.unmountComponentAtNode(document.getElementById('name-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentProductsList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOutItemDetail.name, keyPressed, itemClicked])

  useEffect(() => {
    // Check if the item_full_description is found
    const item = productsList
      .find((product) => ( product.item_full_description.toLowerCase() === stockOutItemDetail.name.toLowerCase()))

    setCurrentItem(item)

    if (item) {
      setItemUnitDescriptionList(item.item_units.map(item => item.description))
      setStockOutItemDetail({
        ...stockOutItemDetail,
        id: item.item_id,
        unit: (editButtonClick) ? stockOutItemDetail.unit : item.item_units.map(item => item.description)[0]
      })
    } else setItemUnitDescriptionList([])

    if (!editButtonClick) stockOutItemDetail.expiration_date = ''

    setEditButtonClick(false)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOutItemDetail.name])

  useEffect(() => {
    if (currentItem) {
      // Know the current item's unit fractional property if true
      const fractional = currentItem.item_units.find(item_unit => item_unit.description === stockOutItemDetail.unit).fractional
      setCurrentUnitIsFractional(fractional)

      // Set it's own expirations array as well
      const current_item_unit = currentItem.item_units.find(item => item.description === stockOutItemDetail.unit)
      const item_unit_current_warehouse = current_item_unit.warehouses.find(wh => wh.warehouse_id === stockOut.source_warehouse.id)

      // Clone expirations from currentItem
      let arr_expirations = null
      //if (item_unit_current_warehouse.expirations) {
      if (item_unit_current_warehouse) {
        arr_expirations = JSON.parse(JSON.stringify(item_unit_current_warehouse.expirations))
        arr_expirations = (arr_expirations.length) ? arr_expirations : null
        if (arr_expirations) {
          stockOut.item_details.forEach((item, i) => {
            if (item.expiration_date) {
              const exp_date = arr_expirations
              .find(exp => (new Date(exp.date).getTime() === (new Date(item.expiration_date).getTime())))
              if (exp_date) exp_date.quantity -= item.quantity
            }
          })
        }
      }

      setStockOutItemDetail({...stockOutItemDetail, expirations: arr_expirations})
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOutItemDetail.unit, currentItem])

  useEffect(() => {
    setItemOK(currentItem && (stockOutItemDetail.quantity > 0))
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stockOutItemDetail.quantity, currentItem])

  return (
    <React.Fragment>
      <div id='item-unit-quantity-container'>
        <table className="table-item-unit-details striped-table">
          <thead>
            <tr className='table-header'>
              <th>#</th>
              <th>Item</th>
              <th>Unit</th>
              <th style={{textAlign: 'center'}}>Quantity</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>
          {
            stockOut.item_details.map((item, index) => (
              <tbody key={index}>
                <tr id={index+'item-details-row'}>
                  <td>{index + 1}</td>
                  <td>
                    <div>{item.name}</div>
                    <div
                      style={{display: (item.expiration_date) ? 'block' : 'none'}}
                      className='expiration-date-container'>
                      Expiration Date:&nbsp; <span className='item-expiration-date'>{item.expiration_date}</span>&nbsp;
                      <CloseButton id={index+'cb'} onClick={onClickRemoveExpirationDate} scale={0.8} title='remove expiration date'/>
                    </div>
                  </td>
                  <td>{item.unit}</td>
                  <td style={{textAlign: 'center'}}>{item.quantity}</td>
                  <td>{item.remarks}</td>
                  <th>
                    <div key={index} className='dd-menu'>
                      <button
                        id={index+'action-row-btn'}
                        onClick={onClickDDButton}
                        onFocus={onDDFocus}
                        className={editMode ? 'pospro-action-btn ellips-btn disabled-button' : 'pospro-action-btn ellips-btn'}
                        disabled={editMode}>
                        <FontAwesomeIcon icon='ellipsis-v'/>
                      </button>
                      <div className='action-btn-menu'>
                        <button
                          id={index+'edit-row-btn'}
                          onClick={onClickStockOutEditItem}
                          className="pospro-action-btn edit-row-btn">
                          e
                        </button>
                        <button
                          id={index+'del-row-btn'}
                          onClick={onClickStockOutDeleteItem}
                          className="pospro-action-btn del-row-btn">
                          &times;
                        </button>
                      </div>
                    </div>
                  </th>
                </tr>
              </tbody>
            ))
          }
          <thead>
            <tr>
              <th></th>
              <th>
                <div className='input-container'>
                  <input
                    ref={stockOutItemDetailNameRef}
                    className={(currentItem || stockOutItemDetail.name === '') ? '' : 'not-found'}
                    autoComplete='off'
                    placeholder='search in [brand] [name] [description]'
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onFocus={onFocusItemNameInput}
                    value={stockOutItemDetail.name}
                  />
                  <div id='name-acl-container' className='acl-container'></div>
                </div>
              </th>
              <th>
                <select
                  id="item-unit"
                  onChange={(e) => { setStockOutItemDetail({...stockOutItemDetail, unit: e.target.value}) } }
                  value={stockOutItemDetail.unit}>
                  {
                    itemUnitDescriptionList.map((unit, index) => (
                      <option key={index}>{unit}</option>
                      )
                    )
                  }
                </select>
              </th>
              <th>
                <input
                  style={{textAlign: 'center'}}
                  id='item-quantity'
                  type='number'
                  onChange={(e) => setStockOutItemDetail({
                    ...stockOutItemDetail,
                    quantity: currentUnitIsFractional ? parseFloat(e.target.value) : parseInt(e.target.value)
                  })}
                  value={stockOutItemDetail.quantity}
                />
              </th>
              <th>
                <input
                  id='item-remarks'
                  onChange={(e) => setStockOutItemDetail({...stockOutItemDetail, remarks: e.target.value})}
                  value={stockOutItemDetail.remarks}
                />
              </th>
              <th>
                <button
                  id='stock-out-add-item'
                  className={ itemOK ? 'pospro-action-btn' : 'pospro-action-btn disabled-button' }
                  disabled={!itemOK}
                  onClick={onClickStockOutAddItem}>
                  <FontAwesomeIcon icon='plus' />
                </button>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <StockOutItemListStyle />
    </React.Fragment>
  )
}

function StockOutInner() {
  return (
    <ContentInner>
      <div id='stock-out-container'>
        <StockOutForm />
        <StockOutItemList />
      </div>
      <StockOutInnerStyle />
    </ContentInner>
  )
}

export default React.memo(StockOutInner)
